import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    CarrierLogo,
    List,
    ListAdornment,
    ListBody,
    ListItem,
    Typography,
} from 'wanderu-components';
import {
    generateIsomorphicID,
    spreadAcross,
} from 'wanderu-utils';

import styles from './LinkTable.scss';

const NUM_COLUMNS = 3;

function LinkTable(props) {
    const {
        className,
        columns = NUM_COLUMNS,
        data = [],
        headings = [],
        native = false,
        showLinkBox = false,
        title = '',
        titleProps,
    } = props;

    const columnData = spreadAcross(data, columns);

    return (
        <div className={clsx(styles.root, className)}>
            {title && (
                <Typography
                    className={styles.title}
                    component="h3"
                    variant="h5"
                    {...titleProps}
                >
                    {title}
                </Typography>
            )}
            <div className={styles.table}>
                {columnData.map((column, index) => (
                    <div
                        className={styles.column}
                        key={generateIsomorphicID({ ...column[0], index })}
                    >
                        {headings.length > 0 && (
                            <div
                                className={clsx(
                                    styles.heading,
                                    { [styles.primaryHeading]: index === 0 },
                                )}
                            >
                                {headings.map((heading) => (
                                    <Typography
                                        key={heading}
                                        variant="subtitle"
                                    >
                                        {heading}
                                    </Typography>
                                ))}
                            </div>
                        )}
                        <List
                            className={clsx(
                                styles.list,
                                { [styles.primaryList]: index === 0 },
                            )}
                        >
                            {column.map((row) => (
                                <ListItem
                                    className={clsx(
                                        styles.listItem,
                                        {
                                            [styles.noPadding]: showLinkBox,
                                        },
                                    )}
                                    key={row.linkUrl}
                                >
                                    <ListBody
                                        className={clsx(
                                            styles.anchor,
                                            {
                                                [styles.linkBox]: showLinkBox,
                                            },
                                        )}
                                        component={Typography}
                                        componentProps={{
                                            component: A,
                                            componentProps: {
                                                underline: showLinkBox
                                                    ? 'none'
                                                    : 'hover',
                                                variant: showLinkBox
                                                    ? 'subdued'
                                                    : 'default',
                                                ...(native && { native }),
                                            },
                                            href: row.linkUrl,
                                            variant: 'body2',
                                        }}
                                    >
                                        {!!row.carrierCode && showLinkBox && (
                                            <CarrierLogo
                                                carrierCode={row.carrierCode}
                                                carrierName={row.carrierName}
                                                className={styles.carrierLogo}
                                            />
                                        )}
                                        {row.linkAnchorText}
                                    </ListBody>
                                    {row.linkAdornment && (
                                        <ListAdornment
                                            component={Typography}
                                            componentProps={{
                                                variant: 'body2',
                                            }}
                                        >
                                            {row.linkAdornment}
                                        </ListAdornment>
                                    )}
                                </ListItem>
                            ))}
                        </List>
                    </div>
                ))}
            </div>
        </div>
    );
}

LinkTable.propTypes = {
    className: PropTypes.string,
    columns: PropTypes.number,
    data: PropTypes.arrayOf(PropTypes.object),
    headings: PropTypes.array,
    native: PropTypes.bool,
    showLinkBox: PropTypes.bool,
    title: PropTypes.string,
    titleProps: PropTypes.object,
};

export default LinkTable;
